'use strict';

// Semantic UI Stylesheets
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/list.css');
require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/grid.css');

// D3
import * as timeformat from 'd3-time-format';
import reqwest from 'reqwest';

//region React Imports
import React from 'react';
import PollChart from '../pollChart/PollChart';
import CandidateLabels from '../candidateLabels/CandidateLabels';
//endregion

class Polls extends React.Component {

  chartWidth = 100;
  partyColors = {
    'Dem': 'blue',
    'Rep': 'red',
    'Lib': 'yellow',
    'N/A': 'grey'
  };

  constructor(state) {
    super(state);

    // Calculate End Date
    let endDate = new Date(Date.now());
    endDate.setMonth(endDate.getMonth() + 1);

    // Set default values – important to have real values, otherwise components
    // down the line will fail to render.
    this.state = {
      ... state,
      locale: {
        "decimal": ",",
        "thousands": "'",
        "grouping": [3],
        "currency": ["", "\u00a0CHF"]
      },
      timelocale: {
        "dateTime": "%A, der %e. %B %Y, %X",
        "date": "%d.%m.%Y",
        "time": "%H:%M:%S",
        "periods": ["vormittags", "nachmittags"],
        "days": ["Sonntag",
          "Montag",
          "Dienstag",
          "Mittwoch",
          "Donnerstag",
          "Freitag",
          "Samstag"],
        "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        "months": ["Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember"],
        "shortMonths": ["Jan",
          "Feb",
          "Mrz",
          "Apr",
          "Mai",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Dez"]
      },
      error: 'Daten werden geladen ...',
      chart: {
        estimates: [
          {choice: 'Clinton', value: 0},
          {choice: 'Trump', value: 0}
        ],
        estimates_by_date: [
          {
            date: "2016-01-01",
            estimates: [
              {choice: 'Clinton', value: 0},
              {choice: 'Trump', value: 0}
            ]
          }
        ]
      },
      lastValues: {
        'Clinton': {
          choice: 'Clinton',
          last_name: 'Clinton',
          color: 'blue',
          value: 0
        },
        'Trump': {
          choice: 'Trump',
          last_name: 'Trump',
          color: 'red',
          value: 0
        },
        'Other': {
          choice: 'Other',
          last_name: 'Other',
          color: 'grey',
          value: 0
        }
      },
      chartWidth: 350,
      chartAspectRatio: {
        width: 100,
        height: 40
      },
      wantedCandidates: ['Clinton', 'Trump'],
      margins: {top: 5, right: 10, bottom: 20, left: 40},
      dateRange: [new Date(2016, 0, 1), endDate]
    };

    // Set timeformat
    timeformat.timeFormatDefaultLocale(this.state.timelocale);

  }

  componentDidMount() {


    //region Chart data
    // Load chart data from pollster

    /* So, this is utterly ridiculous. The Pollster API is public, but it
     doesn't support the CORS mechanism (it doesn't provide the
     Access-Control-Allow-Origin: * header). As such, modern browsers will
     complain and not load the data. In order to make it work anyway, I
     have to use JSONP. Fine, why not – but in order to properly work with
     that, I have to load the complete jQuery library. That's 100KB more
     data, just to get that done. So, so very stupid.
     */

    const url = 'http://elections.huffingtonpost.com/pollster/api/charts/2016-general-election-trump-vs-clinton.json';

    reqwest(
      {
        url: url,
        type: 'jsonp',
        jsonpCallback: 'callback',
        jsonpCallbackName: 'pollsterCallback'
      })
      .then((result) => {

          this.setState({error: ''});
          this.setState({chart: result});

          let values = {};

          let sortedEstimates = result.estimates.sort((a, b) => b.value -
          a.value);

          sortedEstimates.map((estimate) => {
            values[estimate.choice] = {
              ...estimate,
              color: this.partyColors[estimate.party],
              longName: `${estimate.first_name} ${estimate.last_name}`,
            };
          });


          this.setState({lastValues: values});
        },
        (err, msg) => {
          console.log(msg);
        });
    //endregion

  }

  render() {


    return (
      <div className="ui basic vertical infographic">
        <h4 className="ui header">
          Wer in Umfragen landesweit führt
          <div className="sub header meta">Stand vom {timeformat.timeFormat(
            '%x')(Date.now())}
            </div>
        </h4>
        <PollChart
          height={this.state.chartWidth /
          this.state.chartAspectRatio.width *
          this.state.chartAspectRatio.height}
          width={this.state.chartWidth}
          rawData={this.state.chart.estimates_by_date}
          margins={this.state.margins}
          dateRange={this.state.dateRange}
          lastValues={this.state.lastValues}
          aspectRatio={this.state.chartAspectRatio}
          locale={this.state.locale}
          wantedCandidates={this.state.wantedCandidates}
        />
        <div className="ui center aligned fluid container">
          <CandidateLabels
            wantedCandidates={this.state.wantedCandidates}
            lastValues={this.state.lastValues}
            locale={this.state.locale}/>
        </div>
        <div className="ui secondary vertical very fitted segment">
          <div className="ui small list">
            <div className="item"><i className="info circle icon"/>
              <div className="content">
                <p>Die Daten stammen von <a
                href="http://elections.huffingtonpost.com/pollster/2016-general-election-trump-vs-clinton"
                target="_blank">Huffington Post Pollster</a>. Der Dienst sammelt alle Umfragen zu den US-Präsidentschaftswahlen und veröffentlicht aktualisierte Durchschnittswerte. Wir synchronisieren alle Daten hier auf dieser Seite automatisch.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default Polls;



/** WEBPACK FOOTER **
 ** ./src/components/polls/Polls.js
 **/